(function () {
  var BREAKPOINT = 768;

  function isMobile() {
    return window.innerWidth <= BREAKPOINT;
  }

  // Different product templates render the buy buttons with different
  // markup: usually ".cm-product-btns__wrapper" (try-on + choose size, or
  // just choose size), sometimes wrapped one level up in
  // ".cm-product-buy-buttons-block" (which is also what's used for the
  // plain "Tilføj til kurv" button when a product has no variants to
  // choose from), and bundle-style products use ".cm-bundle-atc-wrapper".
  // Try them in this order and use whichever actually exists on the page.
  function findButtonBlock() {
    return document.querySelector('.cm-product-buy-buttons-block')
        || document.querySelector('.cm-product-btns__wrapper')
        || document.querySelector('.cm-bundle-atc-wrapper');
  }

  // Builds a one-off floating copy of the button bar, wired so every
  // control in it just replays a real click on the corresponding control
  // in the original bar - so whatever logic is already bound to the real
  // buttons (ids, delegated listeners, whatever) keeps working untouched.
  function makeFloatingClone(original) {
    var clone = original.cloneNode(true);
    clone.removeAttribute('id');
    clone.classList.add('cm-product-btns__wrapper--floating');

    var originalControls = original.querySelectorAll('button, a, input');
    var cloneControls = clone.querySelectorAll('button, a, input');
    cloneControls.forEach(function (cloneEl, i) {
      cloneEl.removeAttribute('id');
      var originalEl = originalControls[i];
      if (!originalEl) return;
      cloneEl.addEventListener('click', function (e) {
        e.preventDefault();
        originalEl.click();
      });
    });

    document.body.appendChild(clone);
    return clone;
  }

  function setupWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.cmStickyInit) return;
    wrapper.dataset.cmStickyInit = 'true';

    var floatingBar = makeFloatingClone(wrapper);
    var pastOriginal = false;
    var footerInView = false;

    function updateVisibility() {
      if (!isMobile()) {
        floatingBar.classList.remove('cm-btns--visible');
        document.body.classList.remove('cm-sticky-bar-active');
        return;
      }
      var shouldShow = pastOriginal && !footerInView;
      floatingBar.classList.toggle('cm-btns--visible', shouldShow);
      // Lets the chat-widget bubble move up out of the way while the
      // floating bar is showing (see #herodesk-livechat rule in the css).
      document.body.classList.toggle('cm-sticky-bar-active', shouldShow);
    }

    // Only show once the real bar has scrolled above the viewport on the
    // way down. Keep it hidden before that point (e.g. right after page
    // load) and while the real bar is currently visible.
    var wrapperObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      pastOriginal = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      updateVisibility();
    }, { threshold: 0 });
    wrapperObserver.observe(wrapper);

    // Hide the floating bar again once the footer starts coming into view,
    // so it doesn't sit on top of it once you've scrolled all the way down.
    // rootMargin shrinks the viewport a bit so it hides slightly before the
    // footer's edge is actually exposed underneath it.
    var footerEl = document.querySelector('.cm-footer-wrapper');
    if (footerEl) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerInView = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      footerObserver.observe(footerEl);
    }

    window.addEventListener('resize', updateVisibility);
  }

  function init() {
    setupWrapper(findButtonBlock());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
